import React from "react";
import "./Footer.css";

const Footer = () => {
  return <div className="footer"> Geektrust - Finding Falcone</div>;
};

export default Footer;
